import React, { FC } from 'react'

// MUI
import { Breadcrumbs, Container, Grid } from '@mui/material'

// CONSTANTS
import { CONSTANTS } from '@/constants'

// UI
import { BlackNextLink, PaddTwentyFour } from '@/ui'
import { BreadCrumbDiv, BreadCrumbSubTitle, BreadCrumbTitle } from './styles'

type BreadCrumbProps = {
  pageName: string
}

const BreadCrumb: FC<BreadCrumbProps> = props => {
  const { pageName } = props

  return (
    <BreadCrumbDiv>
      <Container maxWidth="xl">
        <PaddTwentyFour>
          <Grid container justifyContent="space-between" alignItems="center" spacing={4}>
            <Grid item>
              <BreadCrumbTitle>{pageName}</BreadCrumbTitle>
            </Grid>
            <Grid item>
              <Breadcrumbs aria-label="breadcrums">
                <BreadCrumbSubTitle>
                  <BlackNextLink href="/" aria-label={`${CONSTANTS.APP_NAME} Home`} aria-labelledby={`${CONSTANTS.APP_NAME} Home`}>
                    Home
                  </BlackNextLink>
                </BreadCrumbSubTitle>

                <BreadCrumbSubTitle>{pageName}</BreadCrumbSubTitle>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </PaddTwentyFour>
      </Container>
    </BreadCrumbDiv>
  )
}

export default BreadCrumb
